/* assets/mf-dr.js - CART DRAWER A/B, MEASUREMENT (RO, 2026-10-18, owner): the old drawer (d0, 68165cb, the control)
   against the new one (d1, cart drawer R d43579f), crossed with the express A/B (assets/mf-xpc.js).

   WHERE IT LIVES. The deal, the html.mf-dr1 switch and the old drawer's DOM fix are the inline dealer above <cart-drawer>
   in sections/mini-cart.liquid (it must run before the drawer can paint; its comment documents the design switch). This
   deferred file only measures, so it rides no /cart?section_id=mini-cart response, and a release that uploads the section
   before this file loses measurement, never the drawer. It runs once per page, after the deferred mf-xpc.js (document
   order), so window.__mfXpc is known here. Literal Liquid delimiters never appear in this file (it is a plain asset).

   INPUT from the dealer: window.__mfDr = the arm (d0 / d1 = the test, dx = outside the read with the old drawer: no
   localStorage, or a browser without :where(); q0 / q1 = QA: nothing measured, nothing tagged; old / new = the setting
   drawer_test outside 'ab': nothing measured, and a cart the test had tagged is cleaned - see ORDERS),
   window.__mfDrFresh = this page dealt a NEW visitor, #mf-dr-cfg data-cart-dr / data-cart-drc = the server cart's mf_dr /
   mf_drc at render, localStorage mf_dr1 = {a, e, v, i, c, k} (the dealer writes a / e / v on every page and carries
   i / c / k while the arm stays): i = the visitor's cart has held items (the di mark went), c = the cell the visitor was
   counted in ('00' '01' '10' '11' = drawer digit + express digit), k = that cell visitor's cart has held items (the ci
   mark went).

   SESSION MARKS - mf-track's SESSION channel (window.mfSesMark; assets/mf-track.js holds the closed list SES_DR and sends
   each mark once per browser session on the next beacon, after the funnel and express marks). Kept in sessionStorage
   mf_dr_sp until mf-track has taken them (a page whose mf-track never loaded hands them to the next pageview). The arm
   digit is appended (0 = d0 old drawer, 1 = d1 new drawer); dx sends only dsx:
     dv  a NEW visitor was dealt                       - sample-ratio check, the visitor denominator
     di  the visitor's first cart with items           - the DECISION denominator (orders per visitor with items)
     ds  a session was dealt (dsx: a dx session)       da  that session's cart held items
     do  that session opened the drawer                dc  a checkout click from the drawer: its checkout button, or an
                                                           express button tapped while mf-xpc shows it enabled (the
                                                           tap mf-xpc also books as cart:checkout_click)
   CELLS - only while the express test is dealt 50/50 too (#mf-xpc-cfg data-mode 'ab', window.__mfXpc x0 / x1): the same
   facts per cell, the drawer digit then the express digit (cs10 = a new-drawer session without the wallet row):
     cv  a visitor first counted in this cell          ci  that cell visitor's first cart with items
     cs  a session in this cell                        ca  that session's cart held items
     co  that session opened the drawer                cc  a checkout click from the drawer (as dc)
   A visitor moves cell only when an arm is re-dealt (30 days without a visit): then cv / ci count it again in the new
   cell. Members with the phantom checkout, and a store without wallets, render no mf-xpc: drawer marks, no cell marks.

   ORDERS: two cart attributes, decided FROM THE CART. mf_dr = the drawer arm (d0 / d1 / dx). mf_drc = the CELL this page
   counted the visitor in ('00' '01' '10' '11'), written under exactly the condition the cell marks go under, '' outside
   the 2x2 (express not 'ab', an xx / xq express arm, members with the phantom checkout, no mf-xpc on the page, dx): the
   beacon books a cell order only from mf_drc, so the cell orders and the cell visitors share one gate by construction -
   when the express test leaves 'ab' the next page with the cart clears mf_drc, as it stops the cell marks. drawer_test
   old / new: both attributes are cleared ('' removes a cart attribute), so the drawer orders stop with the drawer marks.
   The server cart's values at render (data-cart-dr / data-cart-drc) are checked first: a cart with items that differs is
   written AT ONCE (this deferred file runs before mf-xpc's boot check queues its own lock job, so the write settles inside
   the wallet row's first 'wait' and never turns an enabled row back to 'wait'); then every cart event carrying a whole
   cart; one write through window.mfCartLock (one cart writer at a time, shared with the gift keeper and price-tier.js),
   3 writes per page at most; an event without a whole cart is followed by one mfCart read (the shared, deduplicated one)
   1.5 s later, 6 per page at most, and only while this page has not seen its tags on the cart. The checkout pixel
   forwards them as order.dr / order.drc. The contract with the beacon and the pixel: mf-drawer-ab/evidence/CONTRACT.md. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  var arm = W.__mfDr;
  /* old / new = drawer_test outside 'ab': no mark; only the tags a test page left on the cart are cleared */
  var CLEAN = arm === 'old' || arm === 'new';
  if (W.__mfDrM || (arm !== 'd0' && arm !== 'd1' && arm !== 'dx' && !CLEAN)) { return; }
  W.__mfDrM = 1;
  var cfg = D.getElementById('mf-dr-cfg');
  function cfgA(k) { return cfg ? cfg.getAttribute(k) || '' : ''; }
  var cartDr = cfgA('data-cart-dr'), cartDrc = cfgA('data-cart-drc');
  if (CLEAN && !cartDr && !cartDrc) { return; }   /* the server cart carries neither tag: nothing to do on this page */
  var TEST = arm === 'd0' || arm === 'd1';
  var rec = null;
  if (TEST) {
    try { rec = JSON.parse(W.localStorage.getItem('mf_dr1') || 'null'); } catch (e0) { rec = null; }
    if (!rec || rec.a !== arm) { rec = { a: arm, e: Date.now() + 2592e6, v: 1, i: 0, c: '', k: 0 }; }
  }
  function save() { try { if (rec) { W.localStorage.setItem('mf_dr1', JSON.stringify(rec)); } } catch (eS) {} }

  /* ---------------------------------------------------------------- session marks */
  var spMem = [], polling = false, tries = 0, cell = '';
  function spRead() { try { var v = JSON.parse(W.sessionStorage.getItem('mf_dr_sp') || '[]'); return Array.isArray(v) ? v : []; } catch (e1) { return null; } }
  function spWrite(a) { try { if (a.length) { W.sessionStorage.setItem('mf_dr_sp', JSON.stringify(a)); } else { W.sessionStorage.removeItem('mf_dr_sp'); } } catch (e2) {} }
  function spList() { var p = spRead(); return p === null ? spMem : p; }
  function flush() {
    var p = spList();
    if (!p.length) { return; }
    if (typeof W.mfSesMark === 'function') {
      /* true = taken (mf-track owns it until a beacon carries it); false = an unknown name or its session channel is off
         for this browser - nothing could carry it, so it is dropped either way */
      for (var j = 0; j < p.length; j++) { try { W.mfSesMark(p[j]); } catch (e3) {} }
      spMem = []; spWrite([]);
      return;
    }
    if (polling || tries > 240) { return; }   /* 60 s; pending marks stay in storage for the next pageview */
    polling = true;
    setTimeout(function () { polling = false; tries++; flush(); }, 250);
  }
  function put(name) {
    var p = spList();
    if (p.indexOf(name) === -1) { p.push(name); if (p !== spMem) { spWrite(p); } }
    flush();
  }
  /* a drawer mark: m + the arm digit (dx: only the session, as dsx) */
  function mark(m) { if (TEST) { put(m + arm.charAt(1)); } else if (arm === 'dx' && m === 'ds') { put('dsx'); } }
  /* a cell mark: m + drawer digit + express digit, once the cell is known */
  function cmark(m) { if (cell) { put(m + cell); } }
  function readCell() {
    if (!TEST || cell) { return; }
    var x = W.__mfXpc, xc = D.getElementById('mf-xpc-cfg');
    if ((x !== 'x0' && x !== 'x1') || !xc || xc.getAttribute('data-mode') !== 'ab') { return; }
    cell = arm.charAt(1) + x.charAt(1);
    if (rec.c !== cell) { rec.c = cell; rec.k = 0; save(); cmark('cv'); }
    cmark('cs');
  }
  function count() { return (W.mfCart && typeof W.mfCart.count === 'function') ? +W.mfCart.count() || 0 : 0; }
  function withItems() {
    readCell();
    if (!TEST || !(count() > 0)) { return; }
    mark('da');
    if (rec.i !== 1) { rec.i = 1; save(); mark('di'); }
    if (cell) {
      cmark('ca');
      if (rec.k !== 1) { rec.k = 1; save(); cmark('ci'); }
    }
  }

  mark('ds');
  if (TEST && W.__mfDrFresh === true) { mark('dv'); }
  withItems();

  /* ---------------------------------------------------------------- the drawer opened */
  var cd = D.getElementById('mini-cart');
  if (TEST && cd && W.MutationObserver) {
    var wasOpen = cd.hasAttribute('open');
    new W.MutationObserver(function () {
      var on = cd.hasAttribute('open');
      if (on && !wasOpen) { readCell(); mark('do'); cmark('co'); }
      wasOpen = on;
    }).observe(cd, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------------------------------------------------------------- checkout clicks */
  var WALLETS = 'shopify-apple-pay-button, shopify-google-pay-button, shop-pay-wallet-button, shopify-paypal-button, shopify-amazon-pay-button';
  if (TEST) H.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }
    var hit = !!t.closest('cart-drawer [name="checkout"], cart-drawer .checkout-button');
    if (!hit) {
      /* mf-xpc's own rule for an express tap: in its x1 / xq row only while the row is enabled; elsewhere a wallet element */
      var xs = typeof W.__mfXpcState === 'function' ? W.__mfXpcState() : null;
      if (xs && (xs.arm === 'x1' || xs.arm === 'xq')) { hit = !!t.closest('[data-mf-xpc] .mf-xpc__btns') && xs.state === 'ready'; }
      else { hit = !!t.closest(WALLETS); }
    }
    if (hit) { readCell(); mark('dc'); cmark('cc'); }
  }, true);

  /* ---------------------------------------------------------------- the arm and the cell on the cart (orders) */
  /* TAG = this page's mf_dr ('' in old / new: cleared); the cell (mf_drc) is `cell`, known once readCell() succeeded
     ('' for dx, old / new, or outside the 2x2) - both read when written, so a cell found later is written then */
  var TAG = CLEAN ? '' : arm, tagN = 0, tagBusy = false, tagOk = false, looks = 0, lookT = 0;
  function full(c) { return !!c && Array.isArray(c.items) && typeof c.item_count === 'number'; }
  function same(c) { var a = c.attributes || {}; return (a.mf_dr || '') === TAG && (a.mf_drc || '') === cell; }
  function tagWrite() {
    if (tagBusy || tagN >= 3) { return; }
    tagBusy = true; tagN++;
    var job = function () {
      return W.fetch(W.mfHref ? W.mfHref('/cart/update.js') : '/cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { mf_dr: TAG, mf_drc: cell } }), keepalive: true
      });
    };
    (W.mfCartLock ? W.mfCartLock(job) : Promise.resolve().then(job)).then(function (res) {
      tagBusy = false;
      if (res && res.ok) { tagOk = true; }
    }, function () { tagBusy = false; });
  }
  function tagFrom(c) {
    if (!full(c) || !(c.item_count > 0)) { return; }
    if (same(c)) { tagOk = true; return; }
    tagOk = false;
    tagWrite();
  }
  function lookSoon() {
    clearTimeout(lookT);
    lookT = setTimeout(function () {
      if (tagOk || looks >= 6 || !(count() > 0) || !W.mfCart) { return; }
      var c = typeof W.mfCart.peek === 'function' ? W.mfCart.peek() : null;
      if (c) { tagFrom(c); return; }
      looks++;
      W.mfCart.get().then(tagFrom).then(null, function () {});
    }, 1500);
  }
  ['cart:refresh', 'cart:updated', 'variant:added'].forEach(function (name) {
    /* window, capture: sees the event whether it was fired on documentElement, document or window, bubbling or not */
    W.addEventListener(name, function (ev) {
      var c = ev && ev.detail && ev.detail.cart;
      if (full(c)) { tagFrom(c); } else { lookSoon(); }
      setTimeout(withItems, 300);
    }, true);
  });
  /* the server cart at render: a cart with items whose tags differ is written now (no read needed). Not delayed: in an x1
     cell mf-xpc enables the wallet row after its boot check; a write after that would disable the row again for the
     write, a quiet period and a re-read (a tap meanwhile is swallowed). Queued now, it settles inside the row's first
     'wait' (review 2026-10-18, ABCD-2). */
  if (count() > 0 && (cartDr !== TAG || cartDrc !== cell)) { tagWrite(); }
})();
